import React, { Component } from "react";
import { Table, Button, Message, Label } from "semantic-ui-react";

class PassportInOutPrintReport extends Component {
  render() {

    const { transactions, total } = this.props;
    return (
      <Table celled fixed singleLine>
        <Table.Header>
        <Table.Row>
          <Table.HeaderCell colSpan="7" style={{ textAlign:"center" }}>PDC Received Report</Table.HeaderCell>
        </Table.Row>

          <Table.Row>
            <Table.HeaderCell width={1} style={{ textAlign: 'center' }}>Sr</Table.HeaderCell>
            <Table.HeaderCell width={2}>Date</Table.HeaderCell>
            <Table.HeaderCell width={4}>Client</Table.HeaderCell>
            <Table.HeaderCell width={2}>Mobile</Table.HeaderCell>
            <Table.HeaderCell width={4}>Description</Table.HeaderCell>
            <Table.HeaderCell width={2}>Amount</Table.HeaderCell>
            <Table.HeaderCell width={1}>Status</Table.HeaderCell>
          </Table.Row>
        </Table.Header>

        <Table.Body>
          {transactions.map(transaction => (
            <Table.Row>
              <Table.Cell style={{ textAlign: 'center' }}>{transaction.sr}</Table.Cell>
              <Table.Cell>{transaction.date}</Table.Cell>
              <Table.Cell>{transaction.client}</Table.Cell>
              <Table.Cell>{transaction.mobile_no}</Table.Cell>
              <Table.Cell style={{whiteSpace: 'pre-line'}}>
                {transaction.description}<br/>
                <span style={{ fontSize:'11px' }}>{transaction.project != null && transaction.project != ""  ? "Project:"+transaction.project : ""}</span><br/>
                <span style={{ fontSize:'11px' }}>{transaction.account != null && transaction.account != ""  ? "Account:"+transaction.account : "" }</span>
              </Table.Cell>
              <Table.Cell>{transaction.amount}</Table.Cell>
              <Table.Cell>
                {transaction.status == 0 ? "Cleared" : ""}
                {transaction.status == 1 ? "Received" : ""}
              </Table.Cell>
            </Table.Row>
          )
          )}

          {/* <Table.Row>
              <Table.Cell style={{ textAlign:"center" }}></Table.Cell>
              <Table.Cell></Table.Cell>
              <Table.Cell style={{ textAlign:"center" }}></Table.Cell>
              <Table.Cell></Table.Cell>
              <Table.Cell colspan="3" style={{ textAlign:"left",fontSize:'15px' }}><b>{total}</b></Table.Cell>
             
            </Table.Row> */}

        </Table.Body>
      </Table>
    );
  }
}
export default PassportInOutPrintReport;
